import styled from "styled-components"

import { ChevronLeftIcon, ChevronRightIcon } from "@minuthq/meatball-ui-icons"
import { Button, IconButton, spacing } from "@minuthq/meatball-ui-react"

import { useTranslate } from "src/i18n/useTranslate"

type WeekNavigationProps = {
  onPreviousWeek: () => void
  onCurrentWeek: () => void
  onNextWeek: () => void
}

export function WeekNavigation({
  onPreviousWeek,
  onCurrentWeek,
  onNextWeek,
}: WeekNavigationProps) {
  const { t, langKeys } = useTranslate()

  return (
    <NavigationContainer>
      <WeekNavigationContainer>
        <IconButton
          Icon={ChevronLeftIcon}
          onClick={onPreviousWeek}
          size="small"
          variant="subtle"
          aria-label="Previous week"
        />

        <Button variant="subtle" size="small" onClick={onCurrentWeek}>
          {t(langKeys.current_week)}
        </Button>

        <IconButton
          Icon={ChevronRightIcon}
          onClick={onNextWeek}
          size="small"
          variant="subtle"
          aria-label="Next week"
        />
      </WeekNavigationContainer>
    </NavigationContainer>
  )
}

const NavigationContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

const WeekNavigationContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.M};
`
